/**
 * Webmail module registry (DESIGN.md §10.2). Drives the NavRail module switcher and the
 * command palette; Contacts/Tasks are registered as planned.
 */
import type { MessageKey } from '@platform/i18n';
import type { NavRegistry } from '@platform/ui';
import { CalendarIcon, CheckSquareIcon, ContactIcon, FolderOpenIcon, MailIcon, SettingsIcon, ShieldAlertIcon } from 'lucide-react';

export const webmailNavigation: NavRegistry<MessageKey> = [
  {
    id: 'modules',
    label: 'webmail.appName',
    items: [
      { id: 'mail', label: 'webmail.nav.mail', icon: MailIcon, path: '/', template: 'T10', status: 'ready', keywords: ['inbox'] },
      { id: 'calendar', label: 'webmail.nav.calendar', icon: CalendarIcon, path: '/calendar', template: 'T10', status: 'ready', keywords: ['events', 'meetings'] },
      { id: 'publicFolders', label: 'webmail.publicFolders.title', icon: FolderOpenIcon, path: '/folders', template: 'T10', status: 'ready' },
      { id: 'contacts', label: 'webmail.nav.contacts', icon: ContactIcon, path: '/contacts', template: 'T1', status: 'ready' },
      { id: 'tasks', label: 'webmail.nav.tasks', icon: CheckSquareIcon, path: '/tasks', template: 'T1', status: 'ready' },
      { id: 'quarantine', label: 'webmail.quarantine.nav', icon: ShieldAlertIcon, path: '/quarantine', template: 'T1', status: 'ready' },
      { id: 'settings', label: 'webmail.nav.settings', icon: SettingsIcon, path: '/settings', template: 'T5', status: 'ready', keywords: ['signature', 'preferences'] },
    ],
  },
];
